<button type="button" class="btn btn-{{context}} {{class}}" [ngClass]="{'btn-sm': small}" placement="{{tooltipPlacement}}" container="body" [ngbTooltip]="tooltip"
  (click)="onBtnClick(); $event.stopPropagation()">
   <i *ngIf="showIcon || !showCaption" class="fa fa-undo"></i><span *ngIf="showIcon && showCaption">&nbsp;</span><span *ngIf="showCaption">{{'ui.cancel'|translate}}</span>
</button>